const google = window.google

const propertyMap = document.querySelector('.property-map')
const map = document.getElementById('google-map')

const state = {
  map: null,
  bounds: null,
  currentInfoWindow: null,
  locations: [],
  mapCenter: null,
}

const fn = {
  init: () => {
    state.locations = JSON.parse(map.dataset.locations)
    state.mapCenter = new google.maps.LatLng(state.locations[0].lat, state.locations[0].lng)

    fn.setupMap()
  },

  setupMap: () => {
    const opts = {
      center: state.mapCenter,
      zoom: 17,
      maxZoom: 17,
      minZoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    }

    if (!fn.isMobile()) {
      opts.zoomControl = true

      opts.zoomControlOptions = {
        style: google.maps.ZoomControlStyle.LARGE,
        position: google.maps.ControlPosition.RIGHT_CENTER,
      }
    }

    state.map = new google.maps.Map(map, opts)
    state.bounds = new google.maps.LatLngBounds()

    google.maps.event.addListenerOnce(state.map, 'tilesloaded', () => {
      fn.placeMarkers().then(() => {
        state.map.fitBounds(state.bounds)
      })
    })
  },

  placeMarkers: () => {
    const placed = new Promise((resolve) => {
      for (const location of state.locations) {
        fn.setupMarker(location)
        fn.setupInfoWindow(location)
      }

      resolve()
    })

    return placed
  },

  setupMarker: (location) => {
    const marker = new google.maps.Marker({
      map: state.map,
      title: location.label,
      position: new google.maps.LatLng(location.lat, location.lng),
      panposition: new google.maps.LatLng(location.lat, location.lng),
      icon: {
        url: location.marker_url,
        scaledSize: new google.maps.Size(75, 75),
      },
    })

    state.bounds.extend(marker.getPosition())

    google.maps.event.addListener(marker, 'click', () => {
      fn.openInfoWindow(location)
    })

    location.marker = marker
  },

  setupInfoWindow: (location) => {
    const info = new google.maps.InfoWindow({
      content: location.info,
      maxWidth: 320,
    })

    location.infoWindow = info
  },

  openInfoWindow: (location) => {
    if (state.currentInfoWindow && state.currentInfoWindow != location.infoWindow) {
      state.currentInfoWindow.close()
    }

    location.infoWindow.open(state.map, location.marker)
    state.currentInfoWindow = location.infoWindow

    fn.panCenter(location.marker.getPosition(), 0, -120)
  },

  panCenter: (latlng, offsetX, offsetY) => {
    const point1 = state.map
      .getProjection()
      .fromLatLngToPoint(latlng instanceof google.maps.LatLng ? latlng : state.map.getCenter())

    const point2 = new google.maps.Point(
      (typeof offsetX === 'number' ? offsetX : 0) / Math.pow(2, state.map.getZoom()) || 0,
      (typeof offsetY === 'number' ? offsetY : 0) / Math.pow(2, state.map.getZoom()) || 0
    )

    state.map.panTo(
      state.map.getProjection().fromPointToLatLng(new google.maps.Point(point1.x - point2.x, point1.y + point2.y))
    )
  },

  getLocationById: (id) => {
    return state.locations.find((x) => parseInt(x.id) === id)
  },

  isMobile: () => {
    return 'ontouchstart' in document.documentElement
  },
}

export default {
  can: () => propertyMap,
  run: fn.init,
}
